import React, { useState } from "react";

const Button = ({ children, className = "", ...props }) => (
  <button
    className={`bg-blue-600 hover:bg-blue-700 font-semibold rounded-full px-4 py-2 transition ${className}`}
    {...props}
  >
    {children}
  </button>
);

const Card = ({ children, className = "" }) => (
  <div className={`bg-white rounded-xl border shadow-sm ${className}`}>
    {children}
  </div>
);

const CardContent = ({ children, className = "" }) => (
  <div className={`p-4 ${className}`}>{children}</div>
);

const Models = () => {
  const models = [
    {
      type: "M",
      series: "R-Series",
      name: "R15M",
      url: "https://www.yamaha-motor-india.com/yamaha-r15m.html",
      image: "/images/r15M.jpg",
      available: true,
      featured: true,
      price: "₹1,86,000*",
      downPayment: "₹20,000*",
      createdAt: "2025-05-26T00:00:00Z",
    },
    {
      type: "M",
      series: "R-Series",
      name: "R15 V4",
      url: "https://www.yamaha-motor-india.com/yamaha-r15v4.html",
      image: "/images/r15V4-blue.jpg",
      available: true,
      featured: false,
      price: "₹1,71,100*",
      downPayment: "₹19,000*",
      createdAt: "2025-05-26T00:00:00Z",
    },
    {
      type: "M",
      series: "R-Series",
      name: "R15S",
      url: "https://www.yamaha-motor-india.com/yamaha-r15s.html",
      image: "/images/r15S.jpg",
      available: true,
      featured: false,
      price: "₹1,55,600*",
      downPayment: "₹16,000*",
      createdAt: "2025-05-26T00:00:00Z",
    },

    {
      type: "M",
      series: "MT-Series",
      name: "MT-15 Ver 2.0",
      url: "https://www.yamaha-motor-india.com/yamaha-mt-15-v2.html",
      image: "/images/mt15v2.jpg",
      available: true,
      featured: true,
      price: "₹1,63,700*",
      downPayment: "₹15,000*",
      createdAt: "2025-05-26T00:00:00Z",
    },
    {
      type: "M",
      series: "FZ-Series",
      name: "FZ-S Fi Hybrid",
      url: "https://www.yamaha-motor-india.com/yamaha-fzs-fi-hybrid.html",
      image: "/images/fzs-f1-hybrid.jpg",
      available: true,
      featured: false,
      price: "₹1,37,200*",
      downPayment: "₹12,000*",
      createdAt: "2025-05-26T00:00:00Z",
    },
    {
      type: "M",
      series: "FZ-Series",
      name: "FZ-S FI Ver 4.0",
      url: "https://www.yamaha-motor-india.com/yamaha-fzs-fi.html",
      image: "/images/fz-s-f1.jpg",
      available: true,
      featured: false,
      price: "₹1,28,600*",
      downPayment: "₹12,000*",
      createdAt: "2025-05-26T00:00:00Z",
    },
    {
      type: "M",
      series: "FZ-Series",
      name: "FZ-Fi",
      url: "https://www.yamaha-motor-india.com/yamaha-fz-fi.html",
      image: "/images/fz-f1.jpg",
      available: true,
      featured: false,
      price: "₹1,28,600*",
      downPayment: "₹10,999*",
      createdAt: "2025-05-26T00:00:00Z",
    },
    {
      type: "M",
      series: "FZ-Series",
      name: "FZ-X Hybrid",
      url: "https://www.yamaha-motor-india.com/yamaha-fzx.html",
      image: "/images/fz-x.jpg",
      available: true,
      featured: false,
      price: "₹1,42,510*",
      downPayment: "₹13,000*",
      createdAt: "2025-05-26T00:00:00Z",
    },
    {
      type: "S",
      series: "Maxi",
      name: "Aerox 155 Version S",
      url: "https://www.yamaha-motor-india.com/yamaha-aerox-version-s.html",
      image: "/images/aerox15SVs-Sc.jpg",
      available: true,
      featured: true,
      price: "₹1,46,120*",
      downPayment: "₹15,000*",
      createdAt: "2025-05-26T00:00:00Z",
    },
    {
      type: "S",
      series: "Maxi",
      name: "Aerox 155",
      url: "https://www.yamaha-motor-india.com/yamaha-aerox.html",
      image: "/images/aerox-15S-Sc.jpg",
      available: true,
      featured: true,
      price: "₹1,43,120*",
      downPayment: "₹12,000*",
      createdAt: "2025-05-26T00:00:00Z",
    },
    {
      type: "S",
      series: "RayZR",
      name: "RayZR 125 Fi Street Rally",
      url: "https://www.yamaha-motor-india.com/yamaha-ray-zr-street-rally-125-fi.html",
      image: "/images/rayZRStreetRally125Fi.jpg",
      available: true,
      featured: false,
      price: "₹89,760*",
      downPayment: "₹9,999*",
      createdAt: "2025-05-26T00:00:00Z",
    },
    {
      type: "S",
      series: "RayZR",
      name: "RayZR 125 Fi Drum",
      url: "https://www.yamaha-motor-india.com/yamaha-ray-zr-125-fi.html",
      image: "/images/rayZR125Fi.jpg",
      available: true,
      featured: false,
      price: "₹76,960*",
      downPayment: "₹9,999*",
      createdAt: "2025-05-26T00:00:00Z",
    },
    {
      type: "S",
      series: "Fascino",
      name: "Fascino S",
      url: "https://www.yamaha-motor-india.com/yamaha-fascino125fi-new.html",
      image: "/images/fascino125Fi-Sc1.jpg",
      available: true,
      featured: false,
      price: "₹96,200*",
      downPayment: "₹9,999*",
      createdAt: "2025-05-26T00:00:00Z",
    },
    {
      type: "S",
      series: "Fascino",
      name: "Fascino 125 Fi Drum",
      url: "https://www.yamaha-motor-india.com/yamaha-fascino125fi-new.html",
      image: "/images/fascinoDrum.jpg",
      available: true,
      featured: false,
      price: "₹77,200*",
      downPayment: "₹9,999*",
      createdAt: "2025-05-26T00:00:00Z",
    },
  ];

  const [vehicleType, setVehicleType] = useState("motorcycle");
  const typeKey = vehicleType === "motorcycle" ? "M" : "S";
  const filteredModels = models.filter((item) => item.type === typeKey);

  return (
    <section
      id="models"
      className="py-14 bg-gray-50 px-6 md:px-16 scroll-mt-10"
    >
      <h2 className="text-3xl font-semibold text-center mb-6">
        Select Your Vehicle
      </h2>
      <div className="float-right -mt-24">
        <span className="text-yellow-500 border-white">&lt;&lt;&nbsp;</span>
        <a
          href="#contact"
          className="text-blue-900 border-b-2 border-yellow-400 hover:text-yellow-500 font-semibold tracking-wide uppercase md:ml-auto"
        >
          Book a Yamaha Test Ride
        </a>
      </div>

      {/* Vehicle Type Tabs */}
      <div className="flex justify-center mb-6 space-x-6">
        <Button
          className={`px-6 py-2 text-lg ${
            vehicleType === "motorcycle"
              ? "bg-blue-600 text-white"
              : "border bg-white text-gray-400 hover:text-white"
          }`}
          onClick={() => setVehicleType("motorcycle")}
        >
          Motorcycle
        </Button>
        <Button
          className={`px-6 py-2 text-lg ${
            vehicleType === "scooter"
              ? "bg-blue-600 text-white"
              : "border bg-white text-gray-400 hover:text-white"
          }`}
          onClick={() => setVehicleType("scooter")}
        >
          Scooter
        </Button>
      </div>

      <div className="relative w-full mb-6">
        <p
          key={vehicleType}
          className="whitespace-normal text-blue-800 font-medium text-lg text-center"
        >
          {vehicleType === "motorcycle"
            ? <>
                Own your dream bike with a down payment as low as ₹15,999!
                <sup className="text-red-500 ml-1">*</sup>
              </>
            : <>
                Zip away on a Yamaha scooter with just ₹9,999 down payment!
                <sup className="text-red-500 ml-1">*</sup>
              </>
          }
        </p>
      </div>

      {/* Model Cards */}
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
        {filteredModels.map((item) => (
          <Card key={item.name} className="rounded-xl shadow-sm hover:shadow-md hover:border-blue-200 transition-all duration-300 transform hover:-translate-y-0.5 flex flex-col justify-between">
            <CardContent className="flex-grow flex flex-col">
              <div className="w-full h-44 flex items-center justify-center overflow-hidden mb-4 bg-gray-50 rounded-lg">
                <img
                  src={item.image}
                  alt={`${item.name} Yamaha ${item.type === "M" ? "Bike" : "Scooter"} - Excellent Motors`}
                  className="w-full h-full object-contain p-2 transition-transform duration-500 hover:scale-105"
                />
              </div>
              <h3 className="text-lg text-center font-bold mb-3 text-blue-900 uppercase tracking-wide">
                {item.name}
              </h3>
              
              {/* Ex-showroom and Downpayment specifications - subtle styling */}
              <div className="border-t border-gray-100 pt-3 mt-auto space-y-2 text-xs text-gray-500">
                <div className="flex justify-between px-1">
                  <span>Ex-Showroom Price:</span>
                  <span className="font-semibold text-gray-800">{item.price}</span>
                </div>
                <div className="flex justify-between px-1">
                  <span>Min. Down Payment:</span>
                  <span className="font-semibold text-blue-800">{item.downPayment}</span>
                </div>
              </div>
            </CardContent>
            
            {/* Quick action button inside the card */}
            <div className="px-4 pb-4 pt-1">
              <a
                href="#contact"
                className="block text-center bg-blue-800 hover:bg-blue-900 text-white font-bold py-2 rounded-lg transition-colors text-xs uppercase tracking-wider shadow-sm hover:shadow"
              >
                Inquire Price &rarr;
              </a>
            </div>
          </Card>
        ))}
      </div>
      {/* Terms and Conditions Note */}
      <p className="text-sm text-gray-400 mt-4 flex items-start">
        <span className="text-red-500 text-xs mr-1">*</span>
        Terms and conditions apply.
      </p>
    </section>
  );
};

export default Models;
